import { OwnerEnum } from './types';

export const HUBSPOT_FILTER_EVENTS: Record<string, true | readonly OwnerEnum[]> = {
  cancel_flow_retention_offer_accept_click: true,
  cancel_flow_retention_offer_eligibility_denied: true,
  cancel_flow_step1_close_click: true,
  cancel_flow_step2_close_click: true,
  cancel_flow_step2_keep_benefits_click: true,
  dashboard_clients_card_clicked: true,
  dashboard_v2_viewed: true,
  header_help_clicked: true,
  login_attempt_successful: true,
  menu_category_expanded: true,
  menu_gamification_details_clicked: true,
  menu_gamification_details_viewed: true,
  menu_item_selected: true,
  menu_new_tag_clicked: true,
  menu_new_tag_viewed: true,
  menu_profile_mgm_clicked: true,
  notification_tag_clicked: true,
  notification_tag_viewed: true,
  profile_info_displayed: true,
  subscription_b2b_cancellation_whatsapp_clicked: true,
  subscription_regularization_banner_viewed: true,
  subscription_regularization_card_selected: true,
  subscription_regularization_charge_failed: true,
  subscription_regularization_charge_submitted: true,
  subscription_regularization_modal_dismissed: true,
  subscription_regularization_modal_viewed: true,
  subscription_regularization_started: true,
  subscription_regularization_support_clicked: true,
  subscription_support_clicked: true,
  // whatsapp_button_clicked also fires with owner Inovação (JusZap/JusGPT)
  whatsapp_button_clicked: [OwnerEnum.JORNADA],
  // Squad Inovação (IHE-48). jurisprudencia_* chega do micro-front via iframe
  // e é enriquecido em pages/Jurisprudencia antes de passar pelo tracker.
  ia_personalizada_checkout_completed: true,
  ia_personalizada_checkout_opened: true,
  jurisprudencia_external_opened: true,
  jurisprudencia_search: true,
  jus_gpt_chat_message_sent: true,
  jus_zap_upgrade_button_clicked: true,
  juscont_checkout_completed: true,
};

/**
 * Squads que já fecharam a planilha: todo evento delas sai com o campo, e
 * quem não está no registro vai como `false`. As demais seguem sem o campo.
 */
const OWNERS_WITH_FILTRO_HUBSPOT: readonly OwnerEnum[] = [
  OwnerEnum.JORNADA,
  OwnerEnum.INOVACAO,
];

export function resolveFiltroHubspot(
  event: string,
  owner: string,
): boolean | undefined {
  const registryEntry = HUBSPOT_FILTER_EVENTS[event];

  if (registryEntry === true) {
    return true;
  }

  if (Array.isArray(registryEntry) && registryEntry.includes(owner as OwnerEnum)) {
    return true;
  }

  return OWNERS_WITH_FILTRO_HUBSPOT.includes(owner as OwnerEnum)
    ? false
    : undefined;
}
